import * as Types from '../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type RatingsAverageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type RatingsAverageQuery = { __typename?: 'query_root', result?: Types.Maybe<{ __typename?: 'Average', average: number, count: number }> };


export const RatingsAverageDocument = gql`
    query ratingsAverage {
  result: ratings_ratingsAverage {
    average
    count
  }
}
    `;
export function useRatingsAverageQuery(baseOptions?: Apollo.QueryHookOptions<RatingsAverageQuery, RatingsAverageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RatingsAverageQuery, RatingsAverageQueryVariables>(RatingsAverageDocument, options);
      }
export function useRatingsAverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RatingsAverageQuery, RatingsAverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RatingsAverageQuery, RatingsAverageQueryVariables>(RatingsAverageDocument, options);
        }
export type RatingsAverageQueryHookResult = ReturnType<typeof useRatingsAverageQuery>;
export type RatingsAverageLazyQueryHookResult = ReturnType<typeof useRatingsAverageLazyQuery>;
export type RatingsAverageQueryResult = Apollo.QueryResult<RatingsAverageQuery, RatingsAverageQueryVariables>;